import { api } from '../../../configs/api';
import SharedPropsService from '../../../SharedPropsService';
import { decrypt, getAppHeader, isEncrypted, } from '../../../configs/config';
export const fetchLinkRepo = async () => {
    const requestOptions = {
        method: 'GET',
        headers: await getAppHeader(),
    };
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const url = `${api.mandateLink}${applicationId}`;
    return await fetch(url, requestOptions)
        .then(response => response.json())
        .then(async (response) => {
        if (isEncrypted(url)) {
            console.log(response);
            response = JSON.parse(await decrypt(response.result));
        }
        return response;
    })
        .catch(error => console.log('error', error));
};
